import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import Icon1 from "../icons/Icon";
import Space from "../layout/Space";

import { useState } from "react";

import { useSnackbar } from "notistack";

import { useAppContext } from "../config/AppContext";
import SRSIconButton from "../buttons/SRSIconButton";
import SuperModal from "../modals/SuperModal";
import { useParams } from "react-router-dom";

export default function SupportAM({ orgData }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { appState, setAppState } = useAppContext();

  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const open = Boolean(anchorEl);
  const [supportOpen, setSupportOpen] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleOpenSupport = () => {
    setSupportOpen(true);
    handleClose();
  };

  const handleOpenYoutube = () => {
    const url = "https://www.youtube.com/@hexagone-expert";
    window.open(url, "_blank");
    handleClose();
  };

  return (
    <div>
      <SuperModal
        modal_name="support"
        isOpen={supportOpen}
        onClose={() => setSupportOpen(false)}
      ></SuperModal>
    </div>
  );
}
